/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Lamp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M241.22559,152.80762A15.95794,15.95794,0,0,1,227.86768,160H208v32a8,8,0,0,1-16,0V160H136v48h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V160H28.13232a15.99943,15.99943,0,0,1-14.706-22.30273l41.14258-96A15.98283,15.98283,0,0,1,69.27539,32H186.72461a15.98283,15.98283,0,0,1,14.70654,9.69727l41.14258,96A15.95836,15.95836,0,0,1,241.22559,152.80762Z" />
    </Svg>
  );
}

export default Lamp;
